import moment from 'moment';
import { CALCULATOR_URL } from 'constants/Jaws';
import { post } from './fetch';

type Fetcher<T, K> = (options: T) => Promise<K>;

export type CalculateProfitOptions = {
  numberOfShares: number;
  fromDate: Date;
  token: string;
};

export type CalculateProfitReturnState = {
  earnings: any;
  returnPercentageIncludingDividends: any;
  lastDividendDate: any;
  last_dividends: any;
  dividends: any;
};

export const calculateProfit: Fetcher<
  CalculateProfitOptions,
  CalculateProfitReturnState
> = async ({ fromDate = new Date(), token, numberOfShares }) => {
  const options = JSON.stringify({
    fromDate: moment(fromDate).toISOString(),
    key: token,
    numberOfShares,
  });

  const response = await post(CALCULATOR_URL, options);

  if (!response.ok) {
    throw await response; // .text();
  }

  return await response.json();
};
